import { FC } from 'react';
import { View, Text, StyleSheet } from '@react-pdf/renderer';
import { IPDFProject } from '../../../models/pdfReport';
import { coordinatesToString } from '../../../utils/cordinates_helpers';
import Table from './Table'; // reusing the same Table from ProjectTotals

const styles = StyleSheet.create({
    container: {
        paddingTop: '20pt',
    },
    header: {
        fontFamily: 'Roboto',
        fontSize: 32,
        color: '#002342',
    },
    tableContainer: {
        marginTop: 14,
    },
});

interface IProps {
    data: IPDFProject;
}

const LocationSummaryTable: FC<IProps> = ({ data }) => {
    return (
        <View style={styles.container}>
            <Text style={styles.header}>{`Project: ${data.name}`}</Text>
            <View style={styles.tableContainer}>
            <Table
                    title="LOCATION SUMMARY"
                    mode="rows"
                    rows={data.cleanUps.map((cleanUp): { title: string; info: string } => {
                        const status =
                            cleanUp.no_litter_found === true
                                ? 'Checked Clean'
                                : 'New CleanUp';
                        const fullName = cleanUp.location_name || 'Unnamed Location';
                        const truncatedName = fullName.length > 20? `${fullName.slice(0, 24)}...` : fullName;
                        return {
                            title: truncatedName,
                            info: `Length: ${cleanUp.length || 'N/A'} m  |  Coords: ${
                                cleanUp.location
                                    ? coordinatesToString(cleanUp.location)
                                    : 'N/A'
                            }  |  ${status}`,
                        };
                    })}
                />
            </View>
        </View>
    );
};

export default LocationSummaryTable;
